import {useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import associateServices from "../../../services";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import StringHelper from "../../../helpers/string-helper";
import InformationToast from "../../../components/toast/InformationToast";
import PhoneSettings from "./phone";
import {Tooltip} from "react-tooltip";
import SvgIcon from "../../../components/svg-icon";
import CLIPBOARD_HELPER from "../../../helpers/clipboard-helpers";

const GeneralSettings = () => {

    const {user} = useSelector(state => state.authenticationReducer)

    const {t} = useTranslation()
    const [email, setEmail] = useState('')
    const [username, setUsername] = useState('')

    useEffect(() => {
        setEmail(user?.email || '')
        setUsername(user?.username || '')
    }, [user?.email])


    const handleSendOTP = () => associateServices.sendMailToVerify({})
        .then(res => toast.success(t(`api-notifications.${res?.data}`)))


    const handleUpdateUsername = () => {
        associateServices.updateUsername({
            username
        }).then(response => {

            return toast(<InformationToast
                icon={response?.status === 200 ? 'ti-check' : 'ti-error-404'}
                title={response?.status === 200 ? t(`api-notifications.profile-updated`) : '...'}
                message={t(`api-notifications.${response?.data || response?.errors}`)}
            />)
        })
    }

    const handleCopy = (link) => {
        CLIPBOARD_HELPER.copy(link || '')

        toast(<InformationToast
            message={t('affiliate.campaigns.link-copied')}
            title={t('general.information')}
        />)
    }

    return (
        <div
            className="tab-pane fade show active"
            id="tab-1"
            role="tabpanel"
            aria-labelledby="1-tab"
            tabIndex={0}
        >
            <div className="settings">
                <h3 className="settings__title">
                    {t('settings.general.email')}

                    {
                        user?.email_verified_at && <span className="settings__level">
                        <span className="green">
                             {t('general.completed')}
                        </span>
                     </span>
                    }

                </h3>

                <div className="settings__form">
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-12 col-xxl-10">
                            <div className="row">
                                <div className="col-12 col-xl-8 col-xxl-6">
                                    <div className="form__group">
                                        <label htmlFor="" className="form__label">
                                            {t('settings.general.email')} <b>*</b>
                                        </label>
                                        <input
                                            disabled={user?.email_verified_at || true}
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}
                                            type="text" className="form__input"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="settings__actions">
                    <div className="settings__btns">
                        {/*<button*/}
                        {/*    disabled={user?.email_verified_at || false}*/}
                        {/*    className="settings__btn settings__btn--clean"*/}
                        {/*    type="button"*/}
                        {/*    onClick={handleSendOTP}*/}
                        {/*>*/}
                        {/*    {t('settings.general.resend-email')}*/}
                        {/*</button>*/}
                        {/*<button*/}
                        {/*    // onClick={handle}*/}
                        {/*    disabled={user?.email_verified_at || false}*/}
                        {/*    className="settings__btn" type="button">*/}
                        {/*    Save*/}
                        {/*</button>*/}
                    </div>
                </div>
            </div>

            <div className="settings">
                <h3 className="settings__title">
                    {t('settings.general.username')}
                </h3>

                <div className="settings__form">
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-12 col-xxl-10">
                            <div className="row">
                                <div className="col-12 col-xl-8 col-xxl-6">
                                    <div className="form__group">
                                        <label htmlFor="" className="form__label">
                                            {t('settings.general.username')} <b>*</b>
                                        </label>


                                        <div className="form__wallet">
                                            <input
                                                value={username}
                                                disabled
                                                maxLength={16}
                                                type="text" className="form__input"/>
                                            <div className="form__actions">

                                                <Tooltip className="tooltip-me" id="copy-tooltip"/>

                                                <button type="button"
                                                        data-tooltip-id="copy-tooltip"
                                                        data-tooltip-content={'Copy'}
                                                        data-tooltip-place="top"
                                                        onClick={e => handleCopy(username)}
                                                >
                                                    <SvgIcon id={'copy'}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-4 col-xxl-6">
                                    <div className="form__group">
                                        <label htmlFor="" className="form__label">
                                            {t('general.player_id', 'ID')}
                                        </label>


                                        <div className="form__wallet">
                                            <input
                                                value={user?.id || ''}
                                                disabled
                                                type="text" className="form__input"/>
                                            <div className="form__actions">

                                                <Tooltip className="tooltip-me" id="copy-tooltip"/>

                                                <button type="button"
                                                        data-tooltip-id="copy-tooltip"
                                                        data-tooltip-content={'Copy'}
                                                        data-tooltip-place="top"
                                                        onClick={e => handleCopy(user?.id)}
                                                >
                                                    <SvgIcon id={'copy'}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*<div className="settings__actions">*/}
                {/*    <div className="settings__btns">*/}
                {/*        <button*/}
                {/*            disabled={!username || user?.username === username}*/}
                {/*            className="settings__btn settings__btn--clean"*/}
                {/*            type="button"*/}
                {/*            onClick={handleUpdateUsername}*/}
                {/*        >*/}
                {/*            {t('settings.general.update-username')}*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>


            <PhoneSettings/>
        </div>


    )

}


export default GeneralSettings
